import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary max-sm-text-nowrap max-sm-flex-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_draft_order_filter_drown"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-light-primary max-sm-text-nowrap max-sm-flex-1",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "card-body pt-0 vip-table" }
const _hoisted_14 = { class: "mw-100px overflow-hidden" }
const _hoisted_15 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
            class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
            placeholder: _ctx.t('common.search')
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.search]
          ]),
          _withDirectives(_createElementVNode("span", {
            class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
            style: {"cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
          }, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
          ], 512), [
            [_vShow, _ctx.search != '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_window_resize, null, {
            sm: _withCtx(() => [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
              ])
            ]),
            lg: _withCtx(() => [
              _createElementVNode("button", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_FilterDropdown, {
            type: _ctx.type,
            onSubmitFilter: _ctx.handleFilter,
            onResetFilter: _ctx.handleFilterReset
          }, null, 8, ["type", "onSubmitFilter", "onResetFilter"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_MBDatatable, {
        loading: _ctx.loading,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "rows-per-page": _ctx.pageSize,
        onCurrentChange: _ctx.onCurrentPageChange,
        onItemsPerPageChange: _ctx.onRowsPerPageChange,
        onSort: _ctx.onColumnSort
      }, {
        "cell-orderID": _withCtx(({ row: DsSku }) => [
          _createTextVNode(_toDisplayString(DsSku.order_id), 1)
        ]),
        "cell-merchantName": _withCtx(({ row: DsSku }) => [
          _createTextVNode(_toDisplayString(DsSku.merchant_name), 1)
        ]),
        "cell-created_at": _withCtx(({ row: DsSku }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(DsSku.created_at)), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(DsSku.created_at, "YYYY-MM-DD HH:mm")) + " ", 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-packageNumber": _withCtx(({ row: DsSku }) => [
          _createTextVNode(_toDisplayString(DsSku.package_number), 1)
        ]),
        "cell-SKUCount": _withCtx(({ row: DsSku }) => [
          _createTextVNode(_toDisplayString(DsSku.sku_count), 1)
        ]),
        "cell-status": _withCtx(({ row: DsSku }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["badge", _ctx.dsSkuStatusClass(DsSku.status)])
          }, _toDisplayString(_ctx.t(`dsSkuManagement.${_ctx.dsSkuStatusText(DsSku.status)}`)), 3)
        ]),
        "cell-actions": _withCtx(({ row: DsSku }) => [
          _createVNode(_component_router_link, {
            to: '/products/ds-sku-management/' + DsSku.id + '/information',
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
    ])
  ]))
}